exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h3.GTVcY1Y7{font-size:15px;letter-spacing:1px;margin:0 0 24px}p._1BN9TD0C{font-size:13px;font-weight:bold;line-height:1.5;margin:0}p._1BN9TD0C:not(:last-child){margin-bottom:24px}h3.GTVcY1Y7+p._1BN9TD0C{margin-top:24px}", ""]);

// Exports
exports.locals = {
	"heading": "GTVcY1Y7",
	"subheading": "_1BN9TD0C"
};